import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'product',
  initialState: {
    productData: null,
  },
  reducers: {
    setProductData: (state, action) => {
      state.productData = action.payload;
    },
  },
});

export const { setProductData } = slice.actions;
export default slice.reducer;
